import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, ValidationErrors } from "@angular/forms";
import { TranslateService } from "../../../../../node_modules/@ngx-translate/core";
import { DocManagementDataService } from "../../../../providers/doc-management-data-service/doc-management-data-service";

/**
 * Generated class for the DocumentInputComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "document-input",
  templateUrl: "document-input.html",
})
export class DocumentInputComponent implements OnInit {
  @Input() group: FormGroup;
  @Input() config: any;

  text: string;
  id: string;
  componentId: string;
  label: any;
  innerGroup: FormGroup;
  options: string[] = [];
  default: string;
  required: boolean;
  disabled: boolean;
  readonly: boolean = false;

  file;
  fileNameText: any;
  filePath: any;
  patChartId: any;
  order: any;

  payload: any = {};

  constructor(
    public formBuilder: FormBuilder,
    private dataService: DocManagementDataService,
    public translatePipe: TranslateService
  ) {
    console.log("Hello DocumentInputComponent Component");
    this.text = "Hello World";
  }

  ngOnInit() {
    this.id = this.config.id;
    this.patChartId = this.config.patChartId;
    this.order = this.config.order;
    this.componentId = this.config.componentId;
    if (this.config.rules) {
      this.required = this.config.rules.required;
    }

    //add our control to parent form group
    this.group.addControl(this.id, this.formBuilder.control(null));
    this.group.controls[this.id].setErrors(this.getErrors());
  }

  selectFile(e) {
    this.file = e.target.files[0];
    this.fileNameText = this.file.name;
    this.filePath = this.file.dataDirectory + this.file.name;
    this.group.controls[this.id].setValue(this.getCurrentValue());
    this.group.controls[this.id].setErrors(this.getErrors());
  }

  getCurrentValue() {
    if (!this.file) {
      this.group.controls[this.id].setErrors({ required: false });
      return null;
    } else {
      this.payload = {
        key: this.patChartId,
        label: this.translatePipe.instant("orderDocFilePrefix") + this.order.id, //filename
        serviceName: "PatientChart",
        fileExtension: this.file.name.slice(this.file.name.lastIndexOf(".")),
        description:
          this.translatePipe.instant("orderDocumentDescription") +
          this.order.id, //should be the order id and stuff
        category: "Physician Orders",
        patientID: this.patChartId,
      };
      return {
        payload: this.payload,
        file: this.file,
      };
    }
  }

  getErrors(): ValidationErrors {
    let errors = {};
    if (this.required && !this.file) {
      errors["required"] = true;
    }
    return Object.keys(errors).length == 0 ? undefined : errors;
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/document-input/document-input.ts